import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Alert, Button, Snackbar, Card, CardContent, Typography } from "@mui/material";

import { userSelector } from "models/selectors/user";
import { UTILS } from "@/utils";
import { BASE_URL, CONTRACTS_CSV_URL } from "@/constants";
import { LoadingOrContent, VarinerTable } from "@/components";

import { useGetContracts } from "../hooks";

import styles from "./Contracts.module.css";
import { DATE_UTILS } from "utils";

const FILE_NAME = `contracts-${DATE_UTILS.getCurrentDate()}.csv`;

const Contracts = () => {
  const [csv, setCsv] = useState();
  const [copied, setCopied] = useState(false);

  const { user } = useSelector(userSelector);
  const { data: contracts, isLoading } = useGetContracts();

  const { count = "--" } = contracts?.data || {};

  useEffect(() => {
    const csv = UTILS.handleExport(contracts?.data?.data);

    setCsv(csv);
  }, [contracts]);

  const handleCopy = async (textToCopy) => {
    await navigator.clipboard.writeText(textToCopy);
    setCopied(true);
  };

  const authHash = user?.auth_hash || "";
  const url = `${BASE_URL}${CONTRACTS_CSV_URL}?auth_hash=${authHash}`;

  return (
    <>
      <h2>Contracts</h2>

      <LoadingOrContent isLoading={isLoading}>
        <div className={styles.header}>
          <Card
            sx={{ width: 275, display: "flex", alignContent: "center", justifyContent: "center" }}
          >
            <CardContent>
              <Typography variant="h3" component="div">
                {count} Contracts.
              </Typography>
            </CardContent>
          </Card>

          <div className={styles["header-buttons"]}>
            <Button variant="outlined" onClick={() => handleCopy(url)}>
              Generate CSV URL
            </Button>

            {csv && (
              <Button variant="contained" component="a" href={csv} download={FILE_NAME}>
                Download CSV
              </Button>
            )}
          </div>
        </div>

        <Snackbar
          open={copied}
          autoHideDuration={2000}
          onClose={() => setCopied(false)}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <Alert onClose={() => setCopied(false)} severity="success" sx={{ width: "100%" }}>
            ¡URL copied to clipboard!
          </Alert>
        </Snackbar>

        <VarinerTable
          data={contracts?.data?.data}
          fields={[
            "jobOrderId",
            "clientContactFirstName",
            "clientContactLastName",
            "clientCorporationName",
            "jobOrderCustomObjectInstance1Float3",
            "jobOrderCustomObjectInstance1Text1"
          ]}
        />
      </LoadingOrContent>
    </>
  );
};

export { Contracts };
